/*!

=========================================================
* Argon Design System React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-design-system-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-design-system-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState,useEffect,useRef  } from "react";
import ReactDOM from "react-dom";
import axios from 'axios';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
// reactstrap components
import { Container, Row, Col } from "reactstrap";
import { Table } from 'reactstrap';
import { Button } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Form, FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import {setProducts,updateCategory,setQuote,initQuote} from '../actions/quote'
import {setLogo,setSelectedContactUser,setSelectedContactAddress, setSelectedContactInfo,setSelectedCompany, setValidDate, setDeliveryRequired, setPickupInstore, setCollectionId, setQuoteId,setRevise} from '../actions/quote'
import Category from "./Category.js"
import {supplier_arry} from "../config"
import { toast } from 'react-toastify';
import Summary from "./Summary"
import { Badge } from "reactstrap";
// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import CardsFooter from "components/Footers/CardsFooter.js";
import {
  SortableContainer,
  SortableElement,
  arrayMove
} from "react-sortable-hoc";

import "react-virtualized/styles.css";
import "assets/vendor/font-awesome/css/font-awesome.min.css";
import OrderHeader from "./IndexSections/OrderHeader.js";
// index page sections
// import Hero from "./IndexSections/Hero.js";
// import Buttons from "./IndexSections/Buttons.js";
// import Inputs from "./IndexSections/Inputs.js";
// import CustomControls from "./IndexSections/CustomControls.js";
// import Menus from "./IndexSections/Menus.js";
// import Navbars from "./IndexSections/Navbars.js";
// import Tabs from "./IndexSections/Tabs.js";
// import Progress from "./IndexSections/Progress.js";
// import Pagination from "./IndexSections/Pagination.js";
// import Pills from "./IndexSections/Pills.js";
// import Labels from "./IndexSections/Labels.js";
// import Alerts from "./IndexSections/Alerts.js";
// import Typography from "./IndexSections/Typography.js";
import Product from "./IndexSections/Product.js";
// import Datepicker from "./IndexSections/Datepicker.js";
// import TooltipPopover from "./IndexSections/TooltipPopover.js";
// import Carousel from "./IndexSections/Carousel.js";
// import Icons from "./IndexSections/Icons.js";
// import Login from "./IndexSections/Login.js";
// import Download from "./IndexSections/Download.js";






// fake data generator
const getItems = (count, offset = 0) =>
  Array.from({ length: count }, (v, k) => k).map(k => ({
    id: `item-${k + offset}-${new Date().getTime()}`,
    content: `item ${k + offset}`
  }));

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

/**
 * Moves an item from one list to another list.
 */
const move = (source, destination, droppableSource, droppableDestination) => {
  const sourceClone = Array.from(source);
  const destClone = Array.from(destination);
  const [removed] = sourceClone.splice(droppableSource.index, 1);

  destClone.splice(droppableDestination.index, 0, removed);

  const result = {};
  result[droppableSource.droppableId] = sourceClone;
  result[droppableDestination.droppableId] = destClone;

  return result;
};
const grid = 8;

const getItemStyle = (isDragging, draggableStyle, index) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  padding: grid * 2,
  margin: `0 0 0 0`,

  // change background colour if dragging
  background: isDragging ? "lightgreen" : (index%2==0?"white":"#EDECEF"),
  display:'flex',
  width:'100%',
  // styles we need to apply on draggables
  ...draggableStyle
});
const getHeaderStyle = ()=>({
  userSelect: "none",
  padding: grid * 2,
  margin: `0 0 0 0`,
  background:'#091E3F',
  fontWeight:'normal',
  display:'flex',
  width:'100%',
  color:'white',
  borderTopLeftRadius: '20px',
  borderTopRightRadius: '20px'
})
const getListStyle = isDraggingOver => ({
  background: isDraggingOver ? "lightblue" : "white",
  padding: 0,
  width: '100%',
  borderBottom: '6px solid #091E3F',
  minHeight:'80px',
  // marginBottom:'20px'
});

function Index(props) {
  // const [state, setState] = useState([]);
  const [openAddProduct, setOpenAddProduct] = useState(false);
  const [discount, setDiscount] = useState(0);
  const [approvedPrice, setApprovedPrice] = useState(0);
  const main = useRef();
  const [modal, setModal] = useState(false);
  const [noteModal, setNoteModal] = useState(false);
  const [orderId, setOrderId] = useState(null);
  const logoRef = useRef(null);
  const [memoNote, setMemoNote] = useState("");
  const [newMemoNote, setNewMemoNote] = useState("");
  const [orderStatus, setOrderStatus] = useState(null);
  const [quoteStatus, setQuoteStatus] = useState(null);
  const [customiseLogo, setCustomiseLogo] = useState(false);

  const toggle = () => setModal(!modal);
  const toggleNote = () => setNoteModal(!noteModal);
  const toggleAddProduct = () => {
    console.log("toggle");
    setOpenAddProduct(!openAddProduct);
  }
  useEffect(() => {
    props.initQuote()
    let { id } = props.match.params
    axios.get(`/quotes/edit/${id}`).then(res => {
      console.log('res.data',res.data)
      if(res.data.status == "success")
        var quote = res.data.data
        if(quote){
          var categories = JSON.parse(quote.content);
          for(var key in categories){
            var category = {...categories[key]};
            var items = category['items']
            var groups = category['groups']
            for(var loop = 0; loop < items.length; loop++){
              if(groups){
                var group = groups[loop]
                if("fee_price" in group){
                  group['fee_price'] = (group['fee_price']*1).toFixed(2)
                }
                else{
                  group['fee_price'] = (0).toFixed(2)
                }
                if("price" in group){
                  group['price'] = (group['price']*1).toFixed(2)
                }
                else{
                  group['price'] = (0).toFixed(2)
                }
                if("discount_price" in group){
                  group['discount_price'] = (group['discount_price']*1).toFixed(2)
                }
                else{
                  group['discount_price'] = (0).toFixed(2)
                }
                group.cost_visible = false
                items[loop]['group_options'] = group    
              }   
            }
            category['items'] = items;
            categories[key] = category;
          }
          props.updateCategory(categories);
          if(quote.logo){
            // setLogoImage('data:image/png;base64,'+quote.logo)
            // props.setLogo('data:image/png;base64,'+quote.logo)
          }
          setApprovedPrice((quote.approved_price*1).toFixed(2));
          setDiscount((quote.discount*1).toFixed(2))
          setOrderStatus(quote.order_status)
          setQuoteStatus(quote.status)
          setCustomiseLogo(quote.customise_logo)
          setMemoNote(quote.memo_note)

          if(quote.contact_user)
          props.setSelectedContactUser(quote.contact_user)
          if(quote.contact_address)
            props.setSelectedContactAddress(quote.contact_address)
          if(quote.contact_info)
            props.setSelectedContactInfo(quote.contact_info)
          if(quote.valid_to)
            props.setValidDate(quote.valid_to)
          if(quote.delivery_required)
            props.setDeliveryRequired(quote.delivery_required)     
          if(quote.pickup_instore)
            props.setPickupInstore(quote.pickup_instore)
          if(quote.collection_id)
            props.setCollectionId(quote.collection_id)
          if(quote.id)
            props.setQuoteId(quote.id)  
          if(quote.revision)
            props.setRevise(quote.revision) 
        }
    }) 
    setOrderId(id) 
  },[]);


  const renderCategory=()=>{
    const quote = props.quote;
    const categories = quote.categories;
    var elements = [];
    var position = 0;
    for(var index in categories){
      const category = categories[index]
      elements.push(
        <Category history={props.history} mode="view" key={index} position = {position} category={category.category_info} state={category.items} groups={category.groups} updateCategory={props.updateCategory}/>
      )
      position++;
      break;
    }
    return elements;
  }

  const submitOrder=async()=>{
    var quote = props.quote;
    const {
      delivery_required,
      pickup_instore,
      collection_id,
      selectedContactUser
    } = props.quote;
    if(!selectedContactUser){
      toast.error('You must select the contact user. Please try again');
      return;
    }
    if(!delivery_required && !pickup_instore){
      toast.error('You must select a delivery preference. Please try again');
      return;
    }
    if((delivery_required || pickup_instore) && !collection_id){
      toast.error('You must select a collection contact. Please try again');
      return;
    }
    var bodyFormData = new FormData();
    bodyFormData.append('content', JSON.stringify(quote.categories));
    bodyFormData.append('order_status', "Requested Order");
    bodyFormData.append('label',quote.quoteLabel?quote.quoteLabel:"")
    bodyFormData.append('price',quote.totalPrice?quote.totalPrice:"")    
    
    axios.post(`/quotes/edit/${orderId}`, bodyFormData).then(res => {
      const result = res.data;
      if(result.status == "success"){        
        toast.success("Your order has been submitted");
      }
      else{
        toast.error(result.data);
      }
    }).catch(err => {
      toast.error('Something was wrong. Try again');
    })
  }
  
  const repeatOrder=async()=>{
    var quote = props.quote;
    props.history.push("/requests/add?method=repeat")
    // var bodyFormData = new FormData();
    // bodyFormData.append('content', JSON.stringify(quote.categories));
    // if(logoRef.current.files[0])
    //   bodyFormData.append('logo', logoRef.current.files[0]);    
    // axios.post(`/quotes/edit/${orderId}`, bodyFormData).then(res => {
    //   const result = res.data;
    //   if(result.status == "success"){        
    //     toast.success("Your order has been saved");
    //   }
    //   else{
    //     toast.error(result.data);
    //   }
    // }).catch(err => {
    //   toast.error('Something was wrong. Try again');
    // })
  }
  let { id } = props.match.params
  const user = localStorage.getItem('user_bigbrand');
  var role = ""
  if(user && user != undefined){
    var userinfo = JSON.parse(user)
    role = userinfo['role']
  }  
  const addMemo =async()=>{
    var bodyFormData = new FormData();
    bodyFormData.append('memo_note', newMemoNote);

    axios.post(`/quotes/addmemo/${orderId}`, bodyFormData).then(res => {
      const result = res.data;
      if(result.status == "success"){        
        setMemoNote(result.data)
      }
      else{
        toast.error(result.data);
      }
    }).catch(err => {
      toast.error('Something was wrong. Try again');
    })
  }

  const getMemoCount = (memo)=>{
    if(!memo) return 0
    const  newstrings = memo.split("\n"); 
    return newstrings.length;
  }

  return (
    <>
      <DemoNavbar />
      <main ref={main}>
        <Container fluid="lg" className="m-auto">
          <Row>
            <Col  md="12">
              <OrderHeader/>
              {
                renderCategory()
              }

              {role == 'admin'&& 
              <Row style={{marginTop:'60px'}}>
                <Col lg="6">
                  <div className="d-flex" style={{justifyContent:'flex-end'}}>
                    <FormGroup className="text-center">
                      <Label><strong>Approve price</strong></Label>
                      <div className="d-flex align-items-center">
                      $&nbsp;<Input placeholder="Total" disabled value={approvedPrice} onChange={(e)=>setApprovedPrice(e.target.value)} type="number" step="0.01"/>
                      </div>
                    </FormGroup>
                    <FormGroup className="ml-4 text-center">
                      <Label><strong>Discount</strong></Label>
                      <div className="d-flex align-items-center">
                        $&nbsp;<Input placeholder="Discount" disabled value={discount} onChange={(e)=>setDiscount(e.target.value)} type="number" step="0.01"/>
                      </div>
                    </FormGroup>
                    <FormGroup className="ml-4 text-center">
                      <Label className="d-block"><strong>Total</strong></Label>
                      <Label className="mt-2">$&nbsp;<strong>{(parseFloat(approvedPrice) - parseFloat(discount)).toFixed(2)}</strong></Label>
                    </FormGroup>
                  </div>
                </Col>
                <Col lg="6">
                  <Summary/>
                </Col>
              </Row>
              }
              <div className="order-nav" style={{marginTop:'60px'}}>
                <div>
                </div>
                <div>
                  <Button
                    onClick={repeatOrder}
                    color="white" outline
                    className="btn-icon btn-3" type="button">
                    <span className="btn-inner--text">REPEAT QUOTE</span>
                  </Button>
                  <Button
                    onClick={()=>props.history.push(`/requests/edit/${id}`)}
                    color="white" outline
                    className="btn-icon btn-3" type="button">
                    <span className="btn-inner--text">CHANGE QUOTE</span>
                  </Button>
                  <Button
                    onClick={submitOrder}
                    className="btn-icon btn-3" color="primary" type="button">
                    <span className="btn-inner--text">SUBMIT ORDER</span>
                  </Button>
                  <Button
                    onClick={()=>setNoteModal(true)}
                    className="btn-icon btn-3" color="primary" type="button">
                    <i style={{fontSize:20}} className="fa fa-commenting-o" aria-hidden="true"></i>
                    <Badge className="badge-white m-0">{getMemoCount(memoNote)}</Badge>
                  </Button>
                </div>
              </div>
              
            </Col>
          </Row>
          <Modal isOpen={noteModal} toggle={toggleNote} size="md">
            <ModalHeader toggle={toggleNote}>
              <h3 className="h4 font-weight-bold mb-0">
              Conversation Log
              </h3>
            </ModalHeader>
            <ModalBody>
                  <FormGroup>
                    <Input style={{whitespace: 'pre-line'}} disabled type="textarea" rows="8" value={memoNote?memoNote:""}/>                    
                  </FormGroup>
                  <FormGroup>
                    <Input type="input" rows="" value={newMemoNote} onChange={(e)=>setNewMemoNote(e.target.value)}/>
                  </FormGroup>
                  <div style={{display:'flex', justifyContent:'flex-end', padding:"0 20px"}}>
                    <Button color="primary" onClick={()=>addMemo()}>Add</Button>{' '}
                    <Button color="secondary" onClick={toggleNote}>Cancel</Button>
                  </div>
            </ModalBody>            
          </Modal>
        </Container>
      </main>
      <CardsFooter/>
    </>
  );
}


const mapStateToProps = (state) => {
  return {
    quote: state.quote,
  };
};

const mapDispatchProps = (dispatch) => {
  return {    
    setProducts: products=>dispatch(setProducts(products)),
    updateCategory: cat=>dispatch(updateCategory(cat)),
    setQuote: quote=>dispatch(setQuote(quote)),
    initQuote:()=>dispatch(initQuote()),
    setLogo:logo=>dispatch(setLogo(logo)),
    setSelectedContactUser: (selectedContactUser)=>dispatch(setSelectedContactUser(selectedContactUser)),
    setSelectedContactAddress: selectedContactAddress=>dispatch(setSelectedContactAddress(selectedContactAddress)),
    setSelectedContactInfo: data=>dispatch(setSelectedContactInfo(data)),
    setSelectedCompany: selectedCompany=>dispatch(setSelectedCompany(selectedCompany)),
    setValidDate: date=>dispatch(setValidDate(date)),
    setQuoteId: date=>dispatch(setQuoteId(date)),
    setDeliveryRequired: value=>dispatch(setDeliveryRequired(value)),
    setPickupInstore: value=>dispatch(setPickupInstore(value)),
    setCollectionId: value=>dispatch(setCollectionId(value)),
    setRevise:data=>dispatch(setRevise(data)),
  };
};

export default connect(mapStateToProps, mapDispatchProps)(Index);
